import { render, staticRenderFns } from "./LearningClass.vue?vue&type=template&id=137c2663&"
import script from "./LearningClass.vue?vue&type=script&lang=js&"
export * from "./LearningClass.vue?vue&type=script&lang=js&"
import style0 from "./LearningClass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports